(function () {
  if (window.__gpProfessionalBannerBound) return;
  window.__gpProfessionalBannerBound = true;
  function initProfessionalBanner(banner) {
    if (!banner || banner.dataset.slideshowReady === "true") {
      return;
    }

    var slides = Array.prototype.slice.call(banner.querySelectorAll("[data-banner-slide]"));
    if (slides.length < 2) {
      return;
    }

    banner.dataset.slideshowReady = "true";

    var dots = Array.prototype.slice.call(banner.querySelectorAll("[data-banner-dot]"));
    var prev = banner.querySelector("[data-banner-prev]");
    var next = banner.querySelector("[data-banner-next]");
    var interval = parseInt(banner.dataset.interval, 10) || 5000;
    var shouldAutoplay = banner.dataset.autoplay === "true";
    var pauseOnHover = banner.dataset.pauseOnHover === "true";
    var reducedMotion =
      window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var activeIndex = slides.findIndex(function (slide) {
      return slide.classList.contains("is-active");
    });
    var timer = null;

    if (activeIndex < 0) {
      activeIndex = 0;
      slides[0].classList.add("is-active");
    }

    function setActive(index) {
      var nextIndex = (index + slides.length) % slides.length;
      if (nextIndex === activeIndex) {
        return;
      }

      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle("was-active", slideIndex === activeIndex);
        slide.classList.toggle("is-active", slideIndex === nextIndex);
      });

      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === nextIndex;
        dot.classList.toggle("is-active", isActive);
        dot.setAttribute("aria-current", isActive ? "true" : "false");
      });

      activeIndex = nextIndex;

      window.setTimeout(function () {
        slides.forEach(function (slide) {
          slide.classList.remove("was-active");
        });
      }, 1300);
    }

    function goNext() {
      setActive(activeIndex + 1);
    }

    function goPrev() {
      setActive(activeIndex - 1);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (shouldAutoplay && !reducedMotion) {
        timer = window.setInterval(goNext, interval);
      }
    }

    if (next) {
      next.addEventListener("click", function () {
        goNext();
        startAutoplay();
      });
    }

    if (prev) {
      prev.addEventListener("click", function () {
        goPrev();
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        setActive(parseInt(dot.dataset.slideIndex, 10) || 0);
        startAutoplay();
      });
    });

    if (pauseOnHover) {
      banner.addEventListener("mouseenter", stopAutoplay);
      banner.addEventListener("mouseleave", startAutoplay);
      banner.addEventListener("focusin", stopAutoplay);
      banner.addEventListener("focusout", startAutoplay);
    }

    banner.gpBannerCleanup = stopAutoplay;
    startAutoplay();
  }

  function initAllProfessionalBanners(root) {
    var scope = root || document;
    scope.querySelectorAll("[data-growplay-pro-banner]").forEach(initProfessionalBanner);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAllProfessionalBanners(document);
    });
  } else {
    initAllProfessionalBanners(document);
  }

  document.addEventListener("shopify:section:unload", function (event) {
    event.target.querySelectorAll("[data-growplay-pro-banner]").forEach(function (banner) {
      if (banner.gpBannerCleanup) banner.gpBannerCleanup();
    });
  });
  document.addEventListener("shopify:section:load", function (event) {
    initAllProfessionalBanners(event.target);
  });
})();
